import { fetchAuthSession } from 'aws-amplify/auth';
import {
  GET_SESSION_REQUESTED,
  GET_SESSION_COMPLETED,
  GET_SESSION_FAILED,
} from './types';

import debug from '../../services/debug';

const getAction = () => async (dispatch) => {
  dispatch({
    type: GET_SESSION_REQUESTED,
  });

  try {
    const payload = await fetchAuthSession();

    debug(GET_SESSION_COMPLETED, payload);

    dispatch({
      type: GET_SESSION_COMPLETED,
      payload,
    });
  } catch (err) {
    debug(GET_SESSION_FAILED, err);

    dispatch({
      type: GET_SESSION_FAILED,
      payload: err,
    });
  }
};

export default getAction;
